import './style.scss';
import SchoolList from "./schoolList";
import FileList from "./fileList";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useRef, useState} from "react";
import {clearFileStatusesErrors, clearSchools, clearSchoolsErrors, getFileStatuses} from "../../actions/schools";
import {
  checkForSchoolFiles,
  getFirstSchoolFiles,
  organizeFileStatuses
} from "../../utils/uploads";
import {
  clearDeleteUploadedFile,
  clearFilesUploaded,
  clearUploadedFile, getSchoolFiles,
} from "../../actions/uploads";
import Alert from "../common/alert";
import {MESSAGES} from "../../constants";
import {useNavigate} from "react-router-dom";
import {setLoadingStatus} from "../../actions/session";
import LoadingSpinner from "../common/loadingSpinner";

const MyData = (props) => {
  const {
    currentDistrict,
  } = props;

  const dispatch = useDispatch();

  const currentUserComposite = useSelector((state) => state.session.currentUserComposite);

  const fileStatusesLoading = useRef(false);

  useEffect(() => {
    async function returnFileStatuses(currentDistrict) {
        fileStatusesLoading.current = true;
        await dispatch(setLoadingStatus(true));
        await dispatch(getFileStatuses(currentDistrict));
        await dispatch(setLoadingStatus(false));
    }

    if (!fileStatusesLoading.current) {
      returnFileStatuses(currentDistrict);
    }
  }, [currentDistrict, dispatch]);

  const schoolStatuses = useSelector((state) => state.schools.schoolStatuses);
  const isLoading = useSelector((state) => state.session.isLoading);

  useEffect(() => {
    if (!schoolStatuses) {
      dispatch(clearUploadedFile());
      dispatch(clearDeleteUploadedFile());
    }
  });


  const schoolFileLists = organizeFileStatuses(schoolStatuses);
  const [files, setFiles] = useState(getFirstSchoolFiles(schoolFileLists));
  const [school, setSchool] = useState((schoolFileLists['Uploaded'][0]) ? schoolFileLists['Uploaded'][0].school : null);
  const [schoolChanged, setSchoolChanged] = useState(false);

  const schoolFiles = useSelector((state) => state.uploads.schoolFiles)

  useEffect(() => {
    if(schoolChanged && schoolFiles) {
      setFiles(checkForSchoolFiles(schoolFiles));
      setSchoolChanged(false);
    }
  }, [schoolChanged, schoolFiles]);

  const onClick = async (school) => {
    await dispatch(clearUploadedFile());
    await dispatch(clearDeleteUploadedFile());
    await dispatch(getSchoolFiles(school));
    await setSchool(school.school);
    await setSchoolChanged(true);
  }


  function getSchoolName(school) {
    return school;
  }

  const deleteUploadedFileSucceeded = useSelector((store) => store.uploads.deleteUploadedFileSucceeded);
  const deleteUploadedFileApiErrors = useSelector((store) => store.uploads.deleteUploadedFileApiErrors);
  const getUploadedFileApiErrors = useSelector((store) => store.uploads.getUploadedFileApiErrors);
  const filesUploaded = useSelector((store) => store.uploads.filesUploaded);
  const fetchSchoolsError = useSelector((store) => store.schools.fetchSchoolsError);
  const fileStatusesErrors = useSelector((store) => store.schools.fileStatusesErrors);

  const navigate = useNavigate();

  return (isLoading) ? <LoadingSpinner/> : (
    <>
      <div className='my-data-header'>
        <div className='my-data-title'>My Data</div>
        <div className='upload-data'><button className='tes-button' disabled={isLoading} onClick={() => {
          dispatch(clearFilesUploaded());
          dispatch(clearSchools());
          dispatch(clearSchoolsErrors());
          dispatch(clearFileStatusesErrors());
          navigate('/upload-data');
        }}>Upload Data</button></div>
      </div>
      <div className='my-data-alerts'>
        {(deleteUploadedFileSucceeded) && <Alert messageType='success' onDismiss={() => dispatch(clearDeleteUploadedFile())}>{MESSAGES.UPLOADS.deleteUploadedFileSucceeded}</Alert>}
        {(deleteUploadedFileApiErrors) && <Alert messageType='error' onDismiss={() => dispatch(clearDeleteUploadedFile())}>{MESSAGES.UPLOADS.deleteUploadedFileApiErrors}</Alert>}
        {(getUploadedFileApiErrors) && <Alert messageType='error' onDismiss={() => dispatch(clearDeleteUploadedFile())}>{MESSAGES.UPLOADS.getUploadedFileApiErrors}</Alert>}
        {(filesUploaded) && <Alert messageType='success' onDismiss={() => dispatch(clearFilesUploaded())}>{MESSAGES.UPLOADS.filesUploadSuccess}</Alert>}
        {fileStatusesErrors && <Alert messageType='error' onDismiss={() => dispatch(clearFileStatusesErrors())}>{MESSAGES.SCHOOLS.fileStatusesErrors}</Alert>}
        {fetchSchoolsError && <Alert messageType='error' onDismiss={() => dispatch(clearSchoolsErrors())}>{MESSAGES.SCHOOLS.fetchSchoolsError}</Alert>}
      </div>
      <div className='my-data-container'>
        <SchoolList schools={schoolFileLists} selectedSchool={school} onClick={onClick}/>
        <FileList
          files={files}
          school={(school) ? getSchoolName(school) : ''}
          currentUserComposite = {currentUserComposite}
        />
      </div>
    </>
  );
}

export default MyData;